export default __webpack_public_path__ + "static/favicon_40x40-a5a52fd8f21ef604d67d5f2a4edb0522.png";